module.exports = __webpack_public_path__ + "media/05aristocrat.5e60f897.mp3";